<section class="app-exposure-agents__container">
  <section class="app-exposure-agents__container__header">
    <span><strong>Agentes de exposición:</strong> {{ agents.length }}</span>
  </section>

  <section class="app-exposure-agents__container__agents">
    <div class="app-exposure-agents__container__agents__headerTab">
      <span>Código</span>
      <span>Concepto</span>
    </div>


    <div class="app-exposure-agents__container__agents__contentTab">

      <div  *ngFor="let agente of agents" class="app-exposure-agents__container__agents__contentTab__item">
        <span>{{agente.codigo}}</span>
        <span>{{agente.concepto}}</span>
      </div>
    </div>

  </section>
</section>
